<!--
  体测数据大屏（模块A · 独立体测）

  ⚠️ 模块边界：只读 sports_test / sports_test_results（独立体测）。
     与「随堂测试」ti_you_*、「体测活动」activity_* 无关。

  2026-10-20 第二轮整改（操作管理闭环）：
  ① 原来进入大屏后**没有切换学校的入口** —— 现场选错学校只能刷新整页（还要重新等加载）。
     现在右下角常驻「切换学校」。
  ② 学校列表接口失败时，选校弹窗里只有一条 toast，下拉永远是空的、弹窗也关不掉，
     彻底卡死。现在弹窗内直接给错误原因 + 「重新加载」按钮。
  ③ 扫码缓冲区原来没有超时/长度上限：扫码枪只扫半截（丢了回车）时脏字符会一直留在
     buffer 里，之后每次扫码都拼在前面 → 永远查不到人，只能刷新页面。
     现在 3 秒无新字符自动清空，并且限制最长 64 字符。
  ④ 「今日已测人数」原来请求了却从未展示；也没有任何刷新时间提示，
     轮询挂了现场完全看不出来。现在顶部显示「今日已测」+「最后更新」。
  ⑤ 扫码查询加 loading 遮罩（原来点了没反应会以为坏了）。
-->
<template>
  <div>

    <el-dialog title="选择学校" :close-on-click-modal="false"
               :close-on-press-escape="false" v-model="dialogVisible">
      <div style="display:flex;justify-content: center;align-items: center;">
        <div style="margin:0 0.6rem">
          选择本次看板数据学校：
        </div>
        <div style="margin:0 0.6rem">
          <el-select v-model="query.schoolName" placeholder="请选择学校" filterable
                     :loading="schoolLoading" :disabled="schoolLoading" style="width: 280px">
            <el-option v-for="(item,index) in schoolList" :key="index"
                       :label="item.school" :value="item.school"></el-option>
          </el-select>
        </div>
        <div v-if="schoolError" style="color:#f56c6c;font-size:13px;margin-left:10px">
          {{ schoolError }}
        </div>
      </div>
      <div v-if="!schoolLoading && schoolList.length === 0"
           style="text-align:center;color:#909399;font-size:13px;padding-top:14px">
        没有可选学校：只显示「当前可见」的体测计划。
        如果刚导入的学校没出现，请到「体测学员管理 → 体测计划管理」确认该计划的可见截止时间没过期。
      </div>
      <template #footer>
        <el-button v-if="schoolError" @click="loadSchoolList">重新加载学校列表</el-button>
        <el-button type="primary" @click="confirmSchool">确 定</el-button>
      </template>
    </el-dialog>

    <dv-full-screen-container class="box" v-show="!dialogVisible" v-loading="scanLoading"
                              element-loading-text="查询中…">
      <div style="position:absolute;top:4%;left:1%" class="rotating-element">
        <img src="https://minio.yanhuotiyu.com/ossmove/SportsKeCengCredentials/2024/4/9/20240409154351lixin0.png"
             alt="" style="width:46px">
      </div>
      <div style="position:absolute;bottom:2%;right:1%" class="rotating-element">
        <img src="https://minio.yanhuotiyu.com/ossmove/SportsKeCengCredentials/2024/4/9/20240409154351lixin0.png"
             alt="" style="width:46px">
      </div>
      <div style="position:absolute;top:4%;right:1%" class="rotating-element">
        <img src="https://minio.yanhuotiyu.com/ossmove/SportsKeCengCredentials/2024/4/9/20240409154351lixin0.png"
             alt="" style="width:46px">
      </div>
      <div style="position:absolute;bottom:2%;left:1%" class="rotating-element">
        <img src="https://minio.yanhuotiyu.com/ossmove/SportsKeCengCredentials/2024/4/9/20240409154351lixin0.png"
             alt="" style="width:46px">
      </div>

      <!-- 常驻操作区：切换学校 + 刷新状态。原来进入大屏后无法退出/换学校 -->
      <div class="screen-ops">
        <el-button size="small" icon="Back" @click="switchSchool">切换学校</el-button>
        <span class="screen-ops-meta">
          <span v-if="lastRefresh">最后更新 {{ lastRefresh }}</span>
          <span v-else>加载中…</span>
        </span>
      </div>

      <dv-border-box-11 title="焱火体测数据看板" style="font-weight:bold;">
        <div style="height:1.25rem;"></div>
        <div>
          <!-- 学校名称、测试时间、基本信息 -->
          <div style="display:flex;justify-content: space-around;">
            <dv-border-box-1 class="box2">
              <div style="color:#fff;display: flex;justify-content: space-around;margin-top: 1.5rem;font-size: 2rem;">
                <div>测试学校：{{query.schoolName}}</div>
              </div>
              <!-- 今日已测人数：接口一直在返回，之前采集了却没人展示 -->
              <div class="today-line">
                <span class="today-num">{{ todayTestedCount == null ? '—' : todayTestedCount }}</span>
                <span class="today-unit">人今日已测 / 应测 {{ todayStudentCount == null ? '—' : todayStudentCount }}</span>
              </div>

              <!-- 进度 -->
              <div class="project-wrap">
                <div v-if="!loading3">
                  <div class="project-summary">本次体测已开测项目 <b>{{testProjectArr.length}}</b> 项 · 各项目实时测试人数</div>
                  <div class="project-grid">
                    <div v-for="(item,index) in testProjectArr" :key="index" class="project-card">
                      <div class="project-name">{{item.sportsProjectName}}</div>
                      <div class="project-count">
                        <span class="num">{{item.testCount}}</span>
                        <span class="unit">人已测</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="testProjectArr.length === 0" class="project-empty">暂无已测项目数据</div>
                </div>
                <div style="display:flex;justify-content: center;align-items: center;height:10rem;" v-if="loading3">
                  <dv-loading style="color:#fff">Loading...</dv-loading>
                </div>
              </div>

            </dv-border-box-1>
          </div>
          <div style="display: flex;justify-content:space-around;margin-top: 1.25rem;align-items: center;font-weight: bold;font-size: 3rem;color:red">
            <div style="width:35%;text-align:center;padding-left: 3rem;">
              <div style="text-align: center;">
                <img src="https://minio.yanhuotiyu.com/ossmove/SportsKeCengCredentials/2024/4/9/20240409154351lixin0.png"
                     alt="">
              </div>
              <div>四个火，提升快</div>
            </div>
            <div style="text-align:left;width:60%;">
              <div><img src="https://minio.yanhuotiyu.com/ossmove/SportsKeCengCredentials/2024/4/9/20240409154351lixin0.png"
                        alt="" style="visibility: hidden;"></div>
              <div style="font-size:6rem;padding-left: 10rem;">精准测量，公正评判</div>
            </div>
          </div>

        </div>
        <!--           小图表的外边框组件-->
      </dv-border-box-11>
    </dv-full-screen-container>

    <!-- 查看单个学员体测的成绩 弹框 -->
    <el-dialog title="体测成绩" v-model="oneSportsTestStudentDialog" width="98%" center>
      <div class="transcript">
        <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);border-radius: 25px;padding: 20px;width: 80%;margin-left:5%;font-weight: bold;font-size: x-large">
          <div style="display:flex;justify-content: space-between;margin: 10px 0;">
            <div>学生学号:{{ oneRowData.studentIdentity }}</div>
            <div>学生学校:{{ oneRowData.school }}</div>
          </div>
          <div style="display:flex;justify-content: space-between;margin: 10px 0;">
            <div>
              学生姓名 {{ oneRowData.name }}
            </div>
            <div>
              学生性别：{{ oneRowData.sex }}
            </div>
          </div>
          <div style="display:flex;justify-content: space-between;">
            <div>所在班级:{{ oneRowData.className }}</div>
          </div>
          <el-table style="margin-top: 40px;font-size: 20px;font-weight: bold;"
                    :data="oneRowData.testResultsVOS" :row-style="{height:'2px'}">
            <el-table-column prop="sportsProjectName" label="项目"/>
            <el-table-column prop="score" label="成绩"/>
            <el-table-column prop="results" label="得分"/>
          </el-table>
          <div style="font-size:26px;margin:10px 0;text-align:center">
            总分:<span style="color:red">{{ testCount }}</span>!!!
          </div>
        </div>
      </div>
      <div style="text-align:center">
        <audio autoplay="autoplay"
               controls="controls" controlsList="nodownload noplaybackrate"
               preload="auto"
               :src="oneRowData.happyWavPath">
        </audio>
      </div>
      <div style="display: flex;justify-content: center;padding-top: 30px">
        <el-button :size="small" type="primary" @click="oneSportsTestStudentDialog=false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectSportsSchoolAndClass, loadSportTestShow, loadOneSportTestResult
  // selectProjectIdAndName
} from '../../api/physicalTest'

/** 扫码枪缓冲区：3 秒没有新字符就认为这一枪结束了（丢回车时会残留脏数据） */
const BARCODE_IDLE_MS = 3000
/** 条码最长长度：学号/身份证级别都在 32 以内，64 足够且能挡住乱敲键盘 */
const BARCODE_MAX_LEN = 64

export default {
  data() {
    return {
      loading3: false,
      query: {
        schoolName: '',
      },
      scannedBarcode: "",
      oneRowData: {},
      oneSportsTestStudentDialog: false,
      dialogVisible: true,
      schoolList: [],
      schoolLoading: false,
      schoolError: '',
      timer2: {},
      /** 扫码缓冲区空闲清空的定时器 */
      barcodeTimer: null,
      /** 扫码查询中的遮罩 */
      scanLoading: false,
      todayStudentCount: null,
      /** 今日已测人数（今天有成绩提交的学生数）。与 todayStudentCount（应测总数）是两个口径 */
      todayTestedCount: null,
      testProjectArr: [],
      testCount: 0,
      /** 最后一次成功拿到数据的时间（大屏看不出是否卡住） */
      lastRefresh: '',
    }
  },
  created() {
    this.loadSchoolList()
  },
  methods: {
    // ===================== 学校列表 =====================
    /**
     * 拉选校列表。
     *
     * ⚠️ 必须有错误态：原来接口失败只弹一条 toast，下拉永远是空的、弹窗也关不掉，
     *    现场除了刷新整页没有任何出路。
     */
    loadSchoolList() {
      this.schoolLoading = true
      this.schoolError = ''
      selectSportsSchoolAndClass().then(res => {
        if (res && res.code === 200) {
          this.schoolList = res.data || []
        } else {
          this.schoolList = []
          this.schoolError = (res && res.message) || '获取学校列表失败'
          this.$message.error(this.schoolError)
        }
      }).catch(() => {
        this.schoolList = []
        this.schoolError = '网络异常，获取学校列表失败'
        this.$message.error(this.schoolError)
      }).finally(() => {
        this.schoolLoading = false
      })
    },

    // ===================== 扫码录入（扫码枪当键盘）=====================
    handleKeydown(event) {
      // ★ 选校/成绩弹窗开着时一律不收键：用户在下拉框里敲字会被拼进条码，回车就白跑一次请求
      if (this.dialogVisible || this.oneSportsTestStudentDialog) return
      // 若回车键或其他结束字符，则将缓冲区的内容作为条码值处理
      if (event.key === 'Enter' || event.key === ' ') {
        this.clearBarcodeTimer()
        // 空缓冲区直接回车（例如误触）不发请求，避免拿空条码去打后端
        if (this.scannedBarcode) {
          this.loadOneSportTestResult();
        }
        return;
      }
      // 只收单字符键：Shift / F1 / ArrowUp 这类会把脏字符拼进条码
      if (!event.key || event.key.length !== 1) return;
      if (this.scannedBarcode.length >= BARCODE_MAX_LEN) {
        // 超出上限说明这一枪已经乱了，直接重置，避免脏数据无限增长
        this.scannedBarcode = ''
      }
      this.scannedBarcode += event.key;
      // ★ 每次有新字符就重置空闲定时器：扫码枪丢回车时，脏数据不会一直留在 buffer 里
      this.clearBarcodeTimer()
      this.barcodeTimer = setTimeout(() => {
        if (this.scannedBarcode) {
          this.scannedBarcode = ''
        }
      }, BARCODE_IDLE_MS)
    },

    clearBarcodeTimer() {
      if (this.barcodeTimer) {
        clearTimeout(this.barcodeTimer)
        this.barcodeTimer = null
      }
    },

    /**
     * 获取单个体测学员的按评分标准测算后的成绩
     */
    loadOneSportTestResult() {
      const barcode = (this.scannedBarcode || '').trim();
      this.scannedBarcode = "";
      if (!barcode) return;
      // ★ 原来没有反馈：扫码后 1~2 秒内屏幕毫无变化，现场会以为扫码枪坏了，反复扫
      this.scanLoading = true
      this.testCount = 0
      loadOneSportTestResult(barcode).then(val => {
        if (val.code == 200 && val.data) {
          this.oneSportsTestStudentDialog = true;
          this.oneRowData = val.data;
          // ★ 总分口径以后端 now_total_score 为准（心肺复苏按 score 计），
          //   前端累加 results 会在含心肺复苏时与成绩单图片不一致。
          if (val.data.nowTotalScore != null && val.data.nowTotalScore !== '') {
            this.testCount = Number(val.data.nowTotalScore);
          } else if (val.data.testResultsVOS) {
            val.data.testResultsVOS.forEach(e => {
              this.testCount += Number(e.results || 0)
            })
          }
        } else {
          this.$message.error((val && val.message) || '未查到该学员的体测记录！')
        }
      }).catch(() => {
        this.$message.error('网络异常，查询成绩失败！')
      }).finally(() => {
        this.scanLoading = false
      })
    },

    // ===================== 选校 / 切换 =====================
    async confirmSchool() {
      if (!this.query.schoolName) {
        this.$message.error('请选择学校！')
        return
      }
      const checkSchoolIndex = this.schoolList.findIndex(obj => obj.school === this.query.schoolName);
      if (checkSchoolIndex < 0 || !this.schoolList[checkSchoolIndex]) {
        this.$message.error('未找到该学校的数据，请刷新后重试！')
        return
      }
      // ★ 2026-10-20 彻底关掉「班级体测成绩展示」：
      //   该板块 UI 早已注释，但 loadSportTestByMultiClassNameShow + timer(60s) 仍在跑
      //   —— 每 60 秒拉一次最贵的班级成绩聚合，结果无人渲染。连同 config1/loading1/page 一并删除。
      //   现在大屏只保留「各项目已测人数」，靠 timer2 每 60s 刷新。
      clearInterval(this.timer2)
      this.testProjectArr = []
      this.todayStudentCount = null
      this.todayTestedCount = null
      this.lastRefresh = ''
      this.loading3 = true
      try {
        const res = await loadSportTestShow(this.query.schoolName)
        if (res.code === 200 && res.data) {
          // 仅展示"本次体测"中真实已测（testCount>0）的项目，避免把其他学校/未开测项目以0计数带出
          this.applyShowData(res.data)
          this.timer2 = setInterval(() => {
            this.repetitionRequest1()
          }, 60000)
        } else {
          this.$message.error((res && res.message) || '获取学校体测的基础进度失败！')
        }
      } catch (e) {
        this.$message.error('获取学校体测的基础进度失败！')
      } finally {
        // 无论成功失败都进入大屏，避免网络异常时卡在选校弹窗出不来
        this.loading3 = false
        this.dialogVisible = false
      }
    },

    /** 统一落地大屏数据（首屏与轮询共用，避免两处口径漂移） */
    applyShowData(data) {
      const list = (data.sportTypeTestCount || []).filter(i => i.testCount != null && i.testCount > 0)
      this.testProjectArr = list
      this.todayStudentCount = data.todayStudentCount == null ? null : data.todayStudentCount
      this.todayTestedCount = data.todayTestedCount == null ? null : data.todayTestedCount
      this.lastRefresh = this.timeText()
    },

    /**
     * 切换学校：回到选校弹窗。
     *
     * ⚠️ 必须把轮询、数据、条码缓冲一起清掉：
     *    只把弹窗打开不清 timer2，旧学校的 60s 轮询会继续打接口并把新学校的数据覆盖掉。
     */
    switchSchool() {
      clearInterval(this.timer2)
      this.timer2 = {}
      this.clearBarcodeTimer()
      this.scannedBarcode = ''
      this.testProjectArr = []
      this.todayStudentCount = null
      this.todayTestedCount = null
      this.lastRefresh = ''
      this.query.schoolName = ''
      this.dialogVisible = true
      // 上次可能是接口失败才卡住的，回到弹窗时顺手补一次
      if (this.schoolList.length === 0) {
        this.loadSchoolList()
      }
    },

    repetitionRequest1() {
      // ★ 轮询期间不再置 loading3：这是投影常驻的大屏，每 60s 闪一次 Loading 现场很扎眼。
      //   首次进入才由 confirmSchool 控制 loading，这里只做静默替换数据。
      loadSportTestShow(this.query.schoolName).then(res => {
        if (res.code === 200 && res.data) {
          // 一次性替换数组，避免先清空再 push 造成的空白闪动
          this.applyShowData(res.data)
        }
      }).catch(() => {
        // 轮询失败静默，不打断大屏展示；lastRefresh 停在旧时间上，现场能看出数据没在走
      }).finally(() => {
        this.loading3 = false
      })
    },

    timeText() {
      const d = new Date()
      const p = n => (n < 10 ? '0' + n : '' + n)
      return p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
    },
  },

  beforeUnmount() {
    clearInterval(this.timer2)
    this.clearBarcodeTimer()
    // ★ 键盘监听必须解绑：大屏是投影常驻页，切菜单不刷新，
    //   只加不减会让一次扫码触发 N 次查询（N = 进过几次大屏）。
    window.removeEventListener('keydown', this.handleKeydown);
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
}
</script>

<style>
/* 根据具体的情况对图表进整体的布局以及css的修改 */
.box {
  background: rgb(12, 30, 52);
}

.box1 {
  /* margin-left:1.25rem; */
  padding-top:2.5rem;
  height:36vh;
  width:99%;
}
.box2{
  /* margin-left:1.25rem; */
  padding-top:2.5rem;
  height:auto;
  min-height:45vh;
  width:53rem
}

/* 大屏常驻操作区（切换学校 + 最后更新时间） */
.screen-ops {
  position: absolute;
  top: 1%;
  right: 1%;
  z-index: 99;
  display: flex;
  align-items: center;
  gap: 12px;
}

.screen-ops-meta {
  color: #8fd6ff;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

/* 今日已测人数 */
.today-line {
  text-align: center;
  margin-top: 0.4rem;
  color: #8fd6ff;
}
.today-line .today-num {
  font-size: 2.4rem;
  font-weight: 800;
  color: #ffd166;
  text-shadow: 0 0 14px rgba(255,209,102,0.55);
}
.today-line .today-unit {
  font-size: 1rem;
  margin-left: 6px;
  opacity: 0.85;
}

/* 体测项目测试人数 卡片 */
.project-wrap{
  padding: 0 1.2rem 1rem;
}
.project-summary{
  color:#8fd6ff;
  font-size:1.15rem;
  letter-spacing:1px;
  text-align:center;
  margin: 0.4rem 0 1.2rem;
}
.project-summary b{
  color:#5eead4;
  font-size:1.5rem;
  margin:0 4px;
  text-shadow:0 0 10px rgba(94,234,212,0.5);
}
.project-grid{
  display:flex;
  flex-wrap:wrap;
  gap:1rem;
  justify-content:center;
}
.project-card{
  min-width:9.5rem;
  padding:1rem 1.4rem;
  background:linear-gradient(135deg, rgba(124,58,237,0.28), rgba(56,189,248,0.18));
  border:1px solid rgba(124,200,255,0.35);
  border-radius:14px;
  text-align:center;
  color:#fff;
  box-shadow:0 4px 18px rgba(0,0,0,0.35);
  transition:transform .2s ease, box-shadow .2s ease;
}
.project-card:hover{
  transform:translateY(-4px);
  box-shadow:0 8px 26px rgba(124,200,255,0.45);
}
.project-name{
  font-size:1.05rem;
  opacity:0.92;
}
.project-count{
  margin-top:0.45rem;
}
.project-count .num{
  font-size:2.3rem;
  font-weight:800;
  color:#5eead4;
  text-shadow:0 0 12px rgba(94,234,212,0.6);
}
.project-count .unit{
  font-size:0.85rem;
  margin-left:4px;
  opacity:0.8;
}
.project-empty{
  color:#9fb3c8;
  text-align:center;
  padding:2rem 0;
  font-size:1.1rem;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.rotating-element {
  animation: spin 5s linear infinite;
}

</style>
